import { Component, OnInit,ElementRef } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { DataDBService } from '../servicios/data-db.service';
import { PeticionesService } from '../servicios/httpservice';
import { ExcelSerService } from '../servicios/excel-ser.service';

@Component({
  selector: 'app-transitos-generados-encabezado',
  templateUrl: './transitos-generados-encabezado.component.html',
  styleUrls: ['./transitos-generados-encabezado.component.css']
})
export class TransitosGeneradosEncabezadoComponent implements OnInit {
  public arrayAccesos:any[]=[];
  public tagName:any;
  public DatosUsuario:any;
  public spinerTabla:boolean=false;
  public arrayAlmacen:any;
  public arrayTransitos:any[] = [];
  public almacenOrigen:number=-1;
  public almacenDestino:number=-1;
  public almacenes:any;
  public spiner:boolean=false;
  public objetosAgrupadosPorLinea = {}
  public strBusqueda:string;
  public arrayArticulos:any;
  constructor(private _excelService: ExcelSerService,private router: Router, elem: ElementRef,private indexedDBService: DataDBService,private _httpService: PeticionesService) {

    this.tagName = elem.nativeElement.tagName.toLowerCase();
    this.indexedDBService.getItem('arrayResult', (value) => {
      this.arrayAccesos=value?value:[];
      console.log(this.arrayAccesos[0])
      this.DatosUsuario = this.arrayAccesos[0]
      if (this.arrayAccesos.length > 0) {
        console.log(this.arrayAccesos[0]);
        this.DatosUsuario = this.arrayAccesos[0];
        this.fnobteneralmacenes();
        this.fnobtenertransitos();
      } else {
        this.router.navigate(['/login']);
      }
    });
   }

  ngOnInit(): void {
  }
  
  fnobteneralmacenes(){
    this.arrayAlmacen =[];
    this._httpService.getLogisticaPlaneador({strAccion:'getNombresAlmacen'}).subscribe(
      resultados => {
        this.arrayAlmacen =resultados;
        });  
  }
  
  fnobtenertransitos(){
    this.arrayTransitos =[];
    this._httpService.getLogisticaPlaneador({strAccion:'getSalidas_Encabezado'}).subscribe(
      resultados => {
        this.arrayTransitos =resultados;
        this.fnGetDetalle_Todo();
        console.log(this.arrayTransitos);
     
        });  
  }
  fnsumarVolumen( ):number{
     let suma = this.arrayTransitos.reduce((acumulador, registro) => acumulador + registro.dblVolumen, 0);
          return suma;
  }
  fnsumarPeso():number{
    let suma = this.arrayTransitos.reduce((acumulador, registro) => acumulador + registro.dblPeso, 0);
    return suma;
  }
  exportToExcel(){
    let array1 =[];
    if (this.almacenes) {
      const objetosConArrayResult = this.almacenes.filter(objeto => objeto.arrayresult !== undefined && objeto.arrayresult.length > 0);
      array1  = objetosConArrayResult;
      array1.sort((x, y) => x.strAlm_Origen - y.strAlm_Origen);
    }
    else {
      array1=this.arrayTransitos;
    }
   
    let array = []; 
      array1.forEach(ele => {
        let obj = {
          strAlm_OrigenNombre:ele.strAlm_OrigenNombre || '',
          strAlm_Origen:ele.strAlm_Origen || '',
         
          strAlm_destino:ele.strAlm_destino || '',
          strAlm_destinoNombre: ele.strAlm_destinoNombre || '',
     
          dblVolumen: ele.dblVolumen || '' ,
          dblPeso: ele.dblPeso || '' 
        };
        array.push(obj) 
     
      });  
   
  
  
  
  
  
  console.log(array)
  let columns = [
    { header: 'Origen',        key: 'strAlm_OrigenNombre' },
    { header: 'No. Origen',    key: 'strAlm_Origen' },
    { header: 'No. Destino',   key: 'strAlm_destino' },
    { header: 'Destino',       key: 'strAlm_destinoNombre' },
    { header: 'Volumen',       key: 'dblVolumen' },
    { header: 'Peso',          key: 'dblPeso' }
  ];
  this._excelService.exportASExcelFile('Transitos Generados', '',columns , array,[], 'TransitosGenerados', 'Transitos');
  
  }
  fnTransito(Origen:number, destino:number){
    this._httpService.getLogisticaPlaneador({strAccion:'setTransito_Transito', strAlm_Origen:Origen,strAlm_destino:destino}).subscribe(
      resultados => {
        console.log(resultados);
        let code =resultados.length>0? resultados[0].code:0;
        let msj =code>0?'Se generó Tránsito con ID :'+code:'Error al intentar generar tránsito'
         console.log(resultados)
         Swal.fire({
          position: 'center',
          icon: code>0? 'success':'error' ,
          title: msj,
          showConfirmButton: true
        });
        });  
        this.fnEliminar(Origen,destino);
  }
  fnGetDetalle_Todo (){//Origen:number,destino:number
   
    this._httpService.getLogisticaPlaneador({strAccion:'getSalidas_Detalle_Todo'}).subscribe(//, strAlm_Origen:Origen,strAlm_destino:destino
      resultados => {
        this.arrayTransitos.forEach((item: any) => {
          let arrayCuerpo=resultados;
          let cuerpo=arrayCuerpo.filter(o=>o.strAlm_Origen==item.strAlm_Origen &&o.strAlm_destino==item.strAlm_destino);
          item.cuerpo=cuerpo;
        
        });  
        console.log(this.arrayTransitos);    
        });  
  }
  /*fnGetDetalle(Origen:number,destino:number){//
    this.arrayArticulos=[];
    this.spinerTabla=false;
    this._httpService.getLogisticaPlaneador({strAccion:'getSalidas_Detalle', strAlm_Origen:Origen,strAlm_destino:destino}).subscribe(//
      resultados => {
        this.arrayTransitos.forEach((item: any) => {
          console.log(item);
        }); 
        this.arrayArticulos=resultados;
         this.spinerTabla=true;
        console.log(resultados);    
        });  
  }*/
  fnSetEditar(origen:number,destino:number, opcion:string, intID:number, strArticulo:string, strOpcion:string, Cantidad:number){
    let objEdit = {  strAccion:'setEditar_Detalle', intID:intID,strArticulo:strArticulo,strLinea:opcion,dblCantidad:Cantidad,strOpcion:strOpcion}
   console.log(objEdit);
    this._httpService.getLogisticaPlaneador( objEdit).subscribe(
      resultados => {
        let code =resultados.length>0? resultados[0].code:0;
        let msj =code>0?'Se '+opcion+' Correctamente' :'Error al '+opcion
         console.log(resultados)
         Swal.fire({
          position: 'center',
          icon: code>0? 'success':'error' ,
          title: msj,
          showConfirmButton: true
        }); 
        console.log(resultados); 
          if(code==200){
            this.fnEditarArticulo(origen,destino,opcion,intID,strArticulo,strOpcion,Cantidad);
          }
        });   
        
  }
  fnEditarArticulo( origen:number,destino:number,opcion:string, intID:number, strArticulo:string, strOpcion:string, dblCantidad:number){
    let arrayCuerpo = this.arrayTransitos.find(o=>o.strAlm_Origen==origen&& o.strAlm_destino==destino);
    let indice =0;
    if(opcion=='ELIMINAR'){
        indice = arrayCuerpo.cuerpo.findIndex(function(objeto) {
        return objeto.strArticulo === strArticulo && objeto.strOpcion==strOpcion&& objeto.intID==intID ;
      });
      arrayCuerpo.cuerpo.splice(indice, 1);
    }
    else {
        indice = arrayCuerpo.cuerpo.find(function(objeto) {
        return objeto.strArticulo === strArticulo && objeto.strOpcion==strOpcion&& objeto.intID==intID ;
      });
    }
    //calculamos el volumen nuevo
    let volumen=0;
    let peso=0;
    arrayCuerpo.cuerpo.forEach((item: any) => {
      volumen=volumen+(item.dblVolumen * item.dblCantidad)
      peso=peso+(item.dblPeso * item.dblCantidad)
      console.log(item);
    });
    arrayCuerpo.dblVolumen=volumen;
    arrayCuerpo.dblPeso=peso;
    
    console.log(indice);
  }
  fnEliminar(Origen:number, destino:number){
    var indice = this.arrayTransitos.findIndex(function(objeto) {
      return objeto.strAlm_Origen === Origen && objeto.strAlm_destino==destino;
    });
      this.arrayTransitos.splice(indice, 1); // 1 es la cantidad de elemento a eliminar
  }

}
